module.exports = __webpack_public_path__ + "static/img/digital-sst.2dc2c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/digital-sst.png
// module id = lQ9y
// module chunks = 0